<template>
  <div class="page--full contact">
    <el-row type="flex" class="row--full">
      <el-col :sm="15" class="header-and-form">
        <div class="header-and-form__wrapper">
          <h1 class="contact__header">
            <span class="header">Hello. We've been<br />expecting you.</span>
          </h1>
          <p class="contact__subheader">
            Fill in the form, or if you prefer,
            <a href="mailto:hello@sodalabs.co">send us an email</a>.
          </p>
          <el-form
            ref="contactForm"
            class="contact-form"
            name="contact"
            action="/"
            :model="contactForm"
            :rules="rules"
            method="POST"
            data-netlify="true"
            netlify-honeypot="bot-field"
            @submit.prevent.native="handleSubmit"
          >
            <el-input type="hidden" name="bot-field" />
            <el-form-item prop="name">
              <el-input
                v-model="contactForm.name"
                name="name"
                type="text"
                placeholder="Your name"
              />
            </el-form-item>
            <el-form-item prop="email">
              <el-input
                v-model="contactForm.email"
                name="email"
                type="email"
                placeholder="Your email"
              />
            </el-form-item>
            <el-form-item prop="content" class="contact-form__textarea">
              <el-input
                class="hidden-xs-only"
                v-model="contactForm.content"
                name="content"
                :rows="2"
                type="textarea"
                placeholder="Talk to us..."
              />
              <el-input
                class="hidden-sm-and-up"
                v-model="contactForm.content"
                name="content"
                :rows="1"
                type="text"
                placeholder="Talk to us..."
              />
            </el-form-item>
            <el-form-item>
              <button
                type="submit"
                class="contact-form__submit btn btn--secondary btn--bounce is-flex middle"
              >
                <span>Send</span>
                <img src="@/assets/images/icons/arrow.svg" />
              </button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
      <el-col :sm="9" class="contact-image hidden-xs-only">
        <ImageWithLoader
          :src="require('@/assets/images/contact/contact.jpg')"
          :preloadSrc="require('@/assets/images/contact/contact_preload.png')"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios';
import qs from 'qs';

import ImageWithLoader from '@/components/ImageWithLoader.vue';

export default {
  components: {
    ImageWithLoader,
  },
  data() {
    return {
      contactForm: {
        name: '',
        email: '',
        content: '',
      },
      rules: {
        name: [{ required: true, message: 'Please fill in your name.', trigger: 'blur' }],
        email: [{ required: true, message: 'Please fill in your email.', trigger: 'blur' }],
        content: [
          {
            required: true,
            message: 'Please let us know why you are contacting us.',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.contactForm.validate(async valid => {
        if (valid) {
          const encodedData = qs.stringify({ ...this.contactForm, 'form-name': 'contact' });
          const options = {
            header: { 'Content-Type': 'application/x-www-form-urlencoded' },
          };
          try {
            await axios.post('/', encodedData, options);
          } catch (e) {
            console.log(e);
          }
          this.$router.push({ name: 'submitted' });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.header-and-form {
  @media (min-width: $sm) {
    display: flex;
    align-items: center;
  }
  &__wrapper {
    padding: 6.625rem 2rem 0;
    @media (min-width: $sm) {
      padding: 0 8.125rem 0;
    }
    @media (min-width: $xl) {
      padding: 0 11.875rem 0;
    }
  }
}

.contact {
  &__header {
    margin-bottom: 1rem;
    @media (min-width: $xl) {
      margin-bottom: 2rem;
    }
  }
  &__subheader {
    color: $color-secondary;
    font-size: 0.875rem;
    font-weight: 400;
    opacity: 0.5;
    @media (min-width: $sm) {
      font-size: 1rem;
    }
    @media (min-width: $xl) {
      font-size: 1.25rem;
    }
    a {
      color: $color-secondary;
      text-decoration: none;
      border-bottom: 1px solid $color-secondary;
    }
  }
}

.contact-form {
  @media (min-width: $xl) {
    // width: 67.5%;
  }
  &__textarea {
    margin-bottom: 1.5rem;
  }
  &__submit {
    @media (min-width: $sm) {
      width: 60%;
    }
  }
}

.contact-image {
  padding: 1.25rem;
  @media (min-width: $xl) {
    padding: 2.25rem;
  }
  .vue-load-image {
    height: 100%;
    /deep/ img {
      height: 100%;
    }
  }
}
</style>
